import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

export const PageDataContext = createContext(null);
export const SeoCaptureContext = createContext(null);

export function usePageData() {
  const data = useContext(PageDataContext);
  const location = useLocation();
  return data?.pathname === location.pathname ? data : null;
}

export function readInitialPageData() {
  const element = document.getElementById("mynavo-page-data");
  if (!element) return null;
  try { return JSON.parse(element.textContent); } catch { return null; }
}
